module.exports = __webpack_public_path__ + "media/images/company/company_04-2ba165f28fe9fcd66c53808b06ea3ca2.jpg";